import React from 'react';
import CountUp from 'react-countup';
import { Flex, Text, Box } from '@chakra-ui/react';
import SanityImage from 'gatsby-plugin-sanity-image';
import { ImageWithCaption } from '../ImageWithCaption';

function StatGridItem({ item }) {
  const { number, afterText, prefix, suffix, icon, image } = item || {};
  return (
    <Flex direction='column' textAlign='left' height='100%' gap={10}>
      <Flex width='100%' direction='column' gap={10} alignItems='flex-start'>
        {icon && (
          <Flex alignItems='center' height='100%' width='50px'>
            <SanityImage {...icon} alt={icon?.asset?.altText} width={100} height={100} />
          </Flex>
        )}
        {image && <ImageWithCaption image={image} width={300} height={175} />}
      </Flex>
      <Box>
        {/* <Box color='black'>
          {number ? (
            <CountUp
              end={number}
              duration={1.5}
              delay={0}
              prefix={prefix !== undefined ? prefix : ''}
              suffix={suffix !== undefined ? suffix : ''}
              separator=','
              enableScrollSpy
              scrollSpyOnce
            >
              {({ countUpRef }) => (
                <Text fontSize='5xl' lineHeight={1.1} fontWeight={600} ref={countUpRef} mt={0} />
              )}
            </CountUp>
          ) : (
            <Text fontSize='6xl' lineHeight={1.1} fontWeight={600} mt={0}>
              {prefix !== undefined ? prefix : ''}
              {suffix !== undefined ? suffix : ''}
            </Text>
          )}
        </Box> */}
        <Box color='black'>
          {number ? (
            <>
              {/* This Text is visually hidden but will be read by screen readers */}
              <Text
                fontSize='5xl'
                lineHeight={1.1}
                fontWeight={600}
                mt={0}
                style={{
                  position: 'absolute',
                  clip: 'rect(1px, 1px, 1px, 1px)',
                  overflow: 'hidden',
                }}
                aria-live='polite'
              >
                {`${prefix}${number.toLocaleString()}${suffix}`}
              </Text>
              {/* The CountUp component is hidden from screen readers */}
              <Box aria-hidden='true'>
                <CountUp
                  end={number}
                  duration={1.5}
                  delay={0}
                  prefix={prefix !== undefined ? prefix : ''}
                  suffix={suffix !== undefined ? suffix : ''}
                  separator=','
                  enableScrollSpy
                  scrollSpyOnce
                >
                  {({ countUpRef }) => (
                    <Text
                      fontSize='5xl'
                      lineHeight={1.1}
                      fontWeight={600}
                      ref={countUpRef}
                      mt={0}
                    />
                  )}
                </CountUp>
              </Box>
            </>
          ) : (
            <Text fontSize='6xl' lineHeight={1.1} fontWeight={600} mt={0}>
              {prefix !== undefined ? prefix : ''}
              {suffix !== undefined ? suffix : ''}
            </Text>
          )}
        </Box>
        <Box width='100%'>
          {afterText && (
            <Text fontWeight={500} marginTop={0} maxWidth='18.75rem' textStyle='h5'>
              {afterText}
            </Text>
          )}
        </Box>
      </Box>
    </Flex>
  );
}

export default StatGridItem;
